<template>
  <div id="page-container">
    <!-- begin #header -->
    <Header/>
    <!-- end #header -->
    <router-view></router-view>
    <vue-ins-progress-bar></vue-ins-progress-bar>

  </div>
</template>

<script>

import Header from "@/components/guest/Header.vue"
export default {
  name: "GuestApp",
  components: {
    Header
  },
}
</script>

<style>

</style>
